import React, { useState, useEffect } from 'react';

import { useLayoutContext } from '@contexts/LayoutContext';

import { onGetOptionNumber } from '@hooks/API/Event/UseEvent';

import MiniLoading from '@components/Gui/MiniLoading';
import { NwButton } from '@components/Gui/NwButton';
import NwSelect from '@components/Gui/NwForm/CustomSelect';
import RadioButtonGroup from '@components/Gui/NwForm/RadioButtonGroup';

const OptionSelector = ({ eventId, modelId, dates, optionNumber, manual, onUpdateOptionNumber }) => {
    const [loading, setLoading] = useState(false);
    const [mobileSelectedValue, setMobileSelectedValue] = useState(optionNumber);
    const { isMobile } = useLayoutContext();

    useEffect(() => {
        if (!optionNumber && !manual) {
            onCheckOptionNumber();
        }
    }, []);

    useEffect(() => {
        if (!eventId && !manual) {
            onCheckOptionNumber();
        }
    }, [JSON.stringify(dates)]);

    useEffect(() => {
        setMobileSelectedValue(optionNumber);
    }, [optionNumber]);

    const onCheckOptionNumber = async () => {
        const data = {
            EventID: eventId,
            ModelID: modelId,
            Dates: dates,
        };

        setLoading(true);
        try {
            const optionNumber = await onGetOptionNumber(data);
            onUpdateOptionNumber(optionNumber[0].SuggestedOptionNumber);
            setLoading(false);
        } catch (error) {
            console.error('Update Option Number Error => ', error);
            setLoading(false);
        }
    };

    const handleMobileSave = () => {
        if (mobileSelectedValue === 'auto') {
            onCheckOptionNumber();
        } else {
            onUpdateOptionNumber(mobileSelectedValue);
        }
    };

    const options = [
        { value: 10, label: 'JOB' },
        ...[...Array(5).keys()].map((key) => ({ value: key + 1, label: key + 1 })),
        { value: 'auto', label: 'auto' },
    ];

    return loading ? (
        <MiniLoading />
    ) : isMobile ? (
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <NwSelect
                value={mobileSelectedValue}
                onChange={setMobileSelectedValue}
                options={options}
                style={{ flex: 1 }}
            />
            <NwButton onClick={handleMobileSave} type="primary" label="Save" />
        </div>
    ) : (
        <RadioButtonGroup
            value={optionNumber}
            onChange={(value) => {
                if (value === 'auto') {
                    onCheckOptionNumber();
                } else {
                    onUpdateOptionNumber(value);
                }
            }}
            size="small"
            options={options}
        />
    );
};

export default OptionSelector;
